import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpInterceptorService } from './service/http-interceptor.service';
import { JwtService } from './service/jwt.service';
import { UserService } from './service/user.service';
import { EMPTY } from 'rxjs';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NgxStripeModule } from 'ngx-stripe';
import { CustomErrorHandler } from './core/error-handler/custom-error-handler';
import { StripeConfigService } from './service/stripe-config.service';
import { environment } from 'src/environments/environment';

registerLocaleData(en);

export function initAuth(jwtService: JwtService, userService: UserService) {
  return () => (jwtService.getToken() ? userService.getCurrentUser() : EMPTY);
}
export function initializeStripeConfig(stripeConfigService: StripeConfigService) {  
  return () => stripeConfigService.loadStripeConfig().toPromise().then(config => {  
    stripeConfigService.setPublicKey(config.stripePublishableKey); // 设置公钥  
  });  
}  
@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NzMessageModule,
    NgxStripeModule.forRoot(environment.stripe.publicKey)//environment.stripe.publicKey
  ],
  providers: [
    StripeConfigService,  
    {  
      provide: APP_BOOTSTRAP_LISTENER,  
      useFactory: initializeStripeConfig,  
      deps: [StripeConfigService],  
      multi: true  
    },  
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [JwtService, UserService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    { provide: NZ_I18N, useValue: en_US },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
 
}
